import { api } from "./api";

export const flanges = {
  standards: () => api.get("/flanges/standards").then((r) => r.data),
  list: (params) => api.get("/flanges", { params }).then((r) => r.data),
  byId: (id) => api.get(`/flanges/${id}`).then((r) => r.data),
};

export const spool = {
  createSession: (payload) =>
    api.post("/spool/sessions", payload).then((r) => r.data),
  getSession: (sid) =>
    api.get(`/spool/sessions/${sid}`).then((r) => r.data),
  live: (sid) => api.get(`/spool/sessions/${sid}/live`).then((r) => r.data),
  /**
   * Measure a spool point. If `coord` is provided (from the bridge's
   * real-hardware station.measure), we pass the actual x/y/z/hz/v/sd
   * so the shot lands where the surveyor is actually pointing. Without
   * `coord`, the backend falls back to its virtual-flange simulator.
   */
  measure: (sid, label, kind = "face1", coord = null) => {
    const body = { label, kind };
    if (coord) {
      body.x = coord.x;
      body.y = coord.y;
      body.z = coord.z;
      body.hz = coord.hz;
      body.v = coord.v;
      body.sd = coord.sd;
    }
    return api.post(`/spool/sessions/${sid}/measure`, body).then((r) => r.data);
  },
  deletePoint: (sid, index) =>
    api.delete(`/spool/sessions/${sid}/points/${index}`).then((r) => r.data),
  finalize: (sid, jobId, force = false) =>
    api
      .post(`/spool/sessions/${sid}/finalize`, null, {
        params: { job_id: jobId, force },
      })
      .then((r) => r.data),
};

// Top-level Spool Survey container CRUD. A Spool Survey holds many flanges;
// the app auto-creates a backing Job when the survey is created so points
// still land in the existing Job/Point store for CSV/GSI export.
export const spoolSurveys = {
  list: () => api.get("/spool-surveys").then((r) => r.data),
  get: (id) => api.get(`/spool-surveys/${id}`).then((r) => r.data),
  create: (payload) => api.post("/spool-surveys", payload).then((r) => r.data),
  update: (id, patch) =>
    api.patch(`/spool-surveys/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/spool-surveys/${id}`).then((r) => r.data),
};
